(function () {
    const section = document.querySelector('#activity-areas');
    if (!section) return;

    const list = section.querySelector('#js-activity-areas-list');
    const img  = section.querySelector('#js-activity-areas-preview-img');
    const text = section.querySelector('#js-activity-areas-preview-text');
    const link = section.querySelector('#js-activity-areas-preview-link');

    if (!list || !img || !text || !link) return;

    let active = list.querySelector('.area.is-active a[data-preview-url]') || null;

    function setActive(a) {
        if (!a || a === active) return;

        const src    = a.dataset.previewImg || '';
        const alt    = a.dataset.previewAlt || '';
        const srcset = a.dataset.previewSrcset || '';
        const sizes  = a.dataset.previewSizes || '';
        const ex     = a.dataset.previewExcerpt || '';
        const url    = a.dataset.previewUrl || a.getAttribute('href') || '';

        if (src) img.src = src;
        img.alt = alt;

        if (srcset) {
            img.setAttribute('srcset', srcset);
            if (sizes) img.setAttribute('sizes', sizes);
        } else {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
        }

        text.textContent = ex;
        link.href = url;

        // classi active
        if (active) {
            active.closest('.area')?.classList.remove('is-active');
            active.removeAttribute('aria-current');
        }
        a.closest('.area')?.classList.add('is-active');
        a.setAttribute('aria-current', 'true');

        active = a;
    }

    // Imposta default sul primo link (se serve)
    const first = list.querySelector('a[data-preview-url]');
    if (first) setActive(first);

    // Hover: resta attivo l’ultimo su cui passi (non facciamo nulla su mouseleave)
    list.addEventListener('mouseover', function (e) {
        const a = e.target.closest('a[data-preview-url]');
        if (!a || !list.contains(a)) return;
        if (a === active) return;
        setActive(a);
    });

    // Accessibilità: quando vai di TAB sulle voci aggiorna la preview
    list.addEventListener('focusin', function (e) {
        const a = e.target.closest('a[data-preview-url]');
        if (!a || !list.contains(a)) return;
        setActive(a);
    });
})();
